import { PackingTaskProcessPage } from "@/features/packing-task/pages/PackingTaskProcessPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/packing-task/$id/process")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["packing_task.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PackingTaskProcessPage,
});
